// extracted by mini-css-extract-plugin
export default {"root":"OrgSwitch_root__5OO4K"};